import React from 'react';

import ArticleFeedItem from '@components/FeedItems/ArticleFeedItem';

import { APPEARED_IN_TITLE } from './constants';

const GraphicsPageRelatedArticles = ({ relatedArticles }) => {
  return (
    <section className="mt-48 md:mt-72">
      <header className="border-0 border-b border-solid border-grayscale-gray pb-6">
        <h2 className="m-0 font-suisse-neue text-body-lg font-normal">{APPEARED_IN_TITLE}</h2>
      </header>
      <div>
        {relatedArticles.map((article) => (
          <ArticleFeedItem
            key={article.id}
            {...article}
            wrapperClassName="last-of-type:border-b-0"
          />
        ))}
      </div>
    </section>
  );
};

export default GraphicsPageRelatedArticles;
